var map = {
	"./ACB.png": 828,
	"./AGRIBANK.png": 1006,
	"./AGRIBANK2.png": 8590,
	"./ATM.png": 7153,
	"./BIDV.png": 856,
	"./Google.png": 5780,
	"./KLB.png": 7927,
	"./KLB2.png": 1033,
	"./Logo_BIDV 2.png": 9690,
	"./MOMO.png": 1674,
	"./MoMo_Logo.png": 2242,
	"./ONEPAY.png": 9658,
	"./PVCB.png": 2935,
	"./QR.png": 1114,
	"./SHB.png": 9090,
	"./VCB.png": 3136,
	"./VCB2.png": 2000,
	"./VIETINBANK.png": 7467,
	"./VIETQR.png": 5920,
	"./VIETTELPAY.png": 7030,
	"./VISA.png": 4571,
	"./VNMART.png": 5347,
	"./VNPAY.png": 5088,
	"./VNPAY1.png": 9602,
	"./VNPAY2.png": 3385,
	"./VNPAYQR.png": 4562,
	"./ZaloPay.png": 8329,
	"./antoan.png": 5220,
	"./demoqr.png": 8677,
	"./fb-icon.png": 1274,
	"./nhanhchong.png": 5783,
	"./thuantien.png": 1176,
	"./tienloi.png": 7200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6680;